import { useState, useEffect } from 'react';
import SimpleLoadingScreen from '../components/SimpleLoadingScreen';

export const useApiLoading = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const handleApiCall = async (apiCall, errorMessage = 'Failed to load content') => {
    try {
      setLoading(true);
      setError(null);
      const result = await apiCall();
      setData(result);
      return result;
    } catch (err) {
      console.error('API Error:', err);
      setError(errorMessage);
      setData(null);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setLoading(true);
    setError(null);
    setData(null);
  };

  return {
    loading,
    error,
    data,
    handleApiCall,
    reset,
    setLoading,
    setError,
    setData
  };
};

export const LoadingScreen = ({ message = 'Loading...' }) => {
  return <SimpleLoadingScreen message={message} />;
};

export const ErrorScreen = ({ error, onRetry, message = 'Unable to Load Content' }) => {
  // Only show if the main app has finished loading
  const isMainAppLoading = document.querySelector('.fixed.inset-0.z-50') !== null;
  
  if (isMainAppLoading) {
    return null;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-purple-900">
      <div className="text-center">
        <div className="w-12 h-12 text-red-500 mx-auto mb-4">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">{message}</h2>
        <p className="text-gray-600 dark:text-gray-400 mb-4">We're experiencing technical difficulties. Please try again later.</p>
        {onRetry && (
          <button 
            onClick={onRetry}
            className="bg-primary-600 hover:bg-primary-700 text-white px-4 py-2 rounded-lg transition-colors"
          >
            Retry
          </button>
        )}
      </div>
    </div>
  );
}; 